// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__17amV","text":"SelectPayment_text__35yv6","title":"SelectPayment_title__1wnei","btn":"SelectPayment_btn__gavoY"};